import React from "react";
import { Input } from "reactstrap";
import Checkbox from "react-simple-checkbox";

const FactoryFields = ({ type, fieldName, value, onChange }) => {
  const changeInput = (e) => onChange(fieldName, e.target.value);
  const changeCheckbox = () => onChange(fieldName, !value);
  switch (type) {
    case "text":
      return <Input type={type} defaultValue={value} onBlur={changeInput} />;
    case "number":
      return <Input type={type} defaultValue={value} onBlur={changeInput} />;
    case "boolean":
      return (
        <Checkbox
          checked={value}
          onChange={changeCheckbox}
          tickAnimationDuration={50}
          backAnimationDuration={100}
        />
      );
    default:
      return <Input defaultValue={value} onBlur={changeInput} />;
  }
};

export default FactoryFields;



// WEBPACK FOOTER //
// ./src/new-components/admin/table/factory-fields.js